import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

import type { CustomElementOptions } from 'vue';
import type { Router, RouterMatcher } from 'vue-router';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const initPlugins = (app: App, router: Router, matcher: RouterMatcher) => {
  // Vue Query нужен блоку «Как вам заказ?» (review-collection):
  // useTravelerOrders/useSubmitTravelerRating построены на useQuery/useMutation.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 3,
      },
    },
  });
  app.use(VueQueryPlugin, { queryClient });
};
